// 主题切换图片
import store from '../store';
const theme = store.state.theme || 'light';
console.log('打印');
console.log(theme);

// 问题是未选中图标
export const unYesSelectImg = {
  light: require('@/assets/images/help/yes.png'),
  dark: require('@/assets/images/help/yes-active.png'),
};
// 问题否未选中图标
export const unNoSelectImgNo = {
  light: require('@/assets/images/help/no.png'),
  dark: require('@/assets/images/help/no-active.png'),
};
// 反馈箭头图标
export const feedbackPiontImg = {
  light: require('@/assets/images/feedback/point.png'),
  dark: require('@/assets/images/feedback/dark/point.png'),
};

// 反馈记录箭头图标
export const feedbackRecordPiontImg = {
  light: require('@/assets/images/help/right-icon.png'),
  dark: require('@/assets/images/help/dark/right-icon.png'),
};
export const logoImg = {
  light: require('@/assets/images/logo@2x.png'),
  dark: require('@/assets/images/logo_dark.png'),
};

export const successImg = {
  light: require('@/assets/images/help/result.png'),
  dark: require('@/assets/images/myCar/unbinding/dark/pic_successes.png'),
};

export const agreeAcountImg = {
  light: require('@/assets/images/accountDelete/agree.png'),
  dark: require('@/assets/images/accountDelete/dark/agree.png'),
};

export const noAgreeAcountImg = {
  light: require('@/assets/images/accountDelete/noAgree.png'),
  dark: require('@/assets/images/accountDelete/dark/noAgree.png'),
};

export const upoadUnbindingImg = {
  light: require('@/assets/images/myCar/unbinding/upload-card@2x.png'),
  dark: require('@/assets/images/myCar/unbinding/dark/upload-card.png'),
};

export const agreeSelectAcountImg = {
  light: require('@/assets/images/accountDelete/agree.png'),
  dark: require('@/assets/images/accountDelete/dark/agreeSelect.png'),
};

export const noAgreeSelectAcountImg = {
  light: require('@/assets/images/accountDelete/noAgree.png'),
  dark: require('@/assets/images/accountDelete/dark/noAgreeSelect.png'),
};

// 删除图标
export const deleteAccountImg = {
  light: require('@/assets/images/accountDelete/delete.png'),
  dark: require('@/assets/images/accountDelete/dark/delete.png'),
};

// 手机验证码箭头
export const imgCfmotoMoveBtn = {
  light: require('@/components/tianaiCaptcha/assets/images/cfmoto/move-btn-arrow@2x.png'),
  dark: require('@/components/tianaiCaptcha/assets/images/cfmoto/dark/move-btn-arrow@2x.png'),
};
export const imgCfmotoMoveBtnSuccess = {
  light: require('@/components/tianaiCaptcha/assets/images/cfmoto/move-btn-success@2x.png'),
  dark: require('@/components/tianaiCaptcha/assets/images/cfmoto/dark/move-btn-success@2x.png'),
};

// 记录图标
export const recordImg = {
  light: require('@/assets/images/help/record.png'),
  dark: require('@/assets/images/help/dark/record.png'),
};

export const imgEmptySearch = {
  light: require('@/assets/images/empty-search.png'),
  dark: require('@/assets/images/dark/empty-search.png'),
};
export const imgEmptyData = {
  light: require('@/assets/images/empty@2x.png'),
  dark: require('@/assets/images/dark/empty@2x.png'),
};

// 上传图标
export const uploadImg = {
  light: require('@/assets/images/feedback/upload-plus@2x.png'),
  dark: require('@/assets/images/feedback/dark/icon_image@2x.png'),
};

export const documentImg = {
  light: require('@/assets/images/feedback/document@3x.png'),
  dark: require('@/assets/images/feedback/dark/document@3x.png'),
};

export const iconOta = {
  light: require('@/assets/images/myCar/ota/icon_ota@2x.png'),
  dark: require('@/assets/images/myCar/ota/dark/icon_ota@2x.png'),
};

// 左移图标
export const iconLeft = {
  light: require('@/assets/images/icon-left-fill@2x.png'),
  dark: require('@/assets/images/icon-left-fill-dark@2x.png'),
};
